import React from 'react';
import { LearnMorePage } from '../components/primary/LearnMorePage';
export const LearnMore = () => {
  return (
    <>
      <LearnMorePage />
    </>
  )
}